// extracted by mini-css-extract-plugin
module.exports = {"Payment":"Payment_Payment__1H60H"};